/**
 * DeadState - Player has died
 */

import BaseState from './BaseState';
import eventBus, { GameEvents } from '../../core/EventBus';

export default class DeadState extends BaseState {
    enter(data) {
        this.player.isDead = true;
        
        // Emit death event
        eventBus.emit(GameEvents.PLAYER_DEATH, {
            x: this.sprite.x,
            y: this.sprite.y,
            cause: data?.cause || 'unknown'
        });

        // Disable physics
        if (this.sprite.body) {
            this.sprite.setStatic(true);
        }

        // Visual feedback
        this.sprite.setAlpha(0.5);
        if (this.player.highlight) {
            this.player.highlight.setAlpha(0.3);
        }
        if (this.player.shadow) {
            this.player.shadow.setVisible(false);
        }
        if (this.player.pullBeam) {
            this.player.pullBeam.setVisible(false);
        }
    }

    update(delta) {
        // No updates while dead
        // Scene handles restart
    }

    exit() {
        // Reset death state if somehow exiting (shouldn't happen normally)
        this.player.isDead = false;
    }
}
